import { IS_DEV_ENV } from "../constants";

export const logger = {
  info(...msg) {
    if (!IS_DEV_ENV) {
      return;
    }
    console.info(...msg);
  },
  table(...msg) {
    if (!IS_DEV_ENV) {
      return;
    }
    console.table(...msg);
  },
  error(...msg) {
    if (!IS_DEV_ENV) {
      return;
    }
    console.error(...msg);
  },
  warn(...msg) {
    if (!IS_DEV_ENV) {
      return;
    }
    console.warn(...msg);
  },
  trace(...msg) {
    if (!IS_DEV_ENV) {
      return;
    }
    console.trace(...msg);
  },
};
